/**
 * /licenta-cpanel — migrated from public/js/cpanel.js.
 * 1. navMenu pe header.licenses .menu pentru slide-uri intre planuri.
 * 2. Accordion .features-box ul cu click pe span.name — toggle clasa toggled si slideToggle.
 */
import { Resort } from '../core/resort.js';

new Resort(() => {
    ($('header.licenses .menu') as Element | null)?.navMenu('a', 'header.licenses .slide');

    ($('.features-box ul') as Element | null)?.on('click', 'span.name', function (this: Element) {
        const ul = this.parentElement;
        ul?.classList.toggle('toggled');
        (this.nextElementSibling as HTMLElement | null)?.slideToggle();

        // Inchide alte items toggled (la max un panel deschis).
        $('.features-box li.toggled', (el: Element) => {
            if (ul !== el) {
                el.classList.remove('toggled');
                (el.findChildren('ul') as HTMLElement | null)?.slideUp(undefined, true);
            }
            return true;
        });
    });
});
